export enum Media {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop'
}

export enum MediaOrientation {
  Portrait = 'portrait',
  Landscape = 'landscape'
}
